import { Cloud } from '@mui/icons-material';
import { NavItemType } from 'types/index.types';

const drive: NavItemType = {
    id: 'drive',
    title: 'components.menu.drive',
    icon: Cloud,
    type: 'item',
    url: '/drive/root',
    routingDisabled: true,
    breadcrumbs: false
};

export default drive;
